import { FC } from "react";

import { Button, Spinner } from "react-bootstrap";

import { Check } from "lucide-react";

interface Props {
  onSubmit: () => void;
  disabled: boolean;
  isLoading?: boolean;
}

const ActionButtons: FC<Props> = ({ onSubmit, disabled, isLoading = false }) => {
  return (
    <div className="space-y-3">
      <Button
        onClick={onSubmit}
        className="w-full bg-purple-600 hover:bg-purple-700 text-white py-3"
        disabled={disabled || isLoading}
      >
        {isLoading ? (
          <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
              className="mr-2"
            />
            Association en cours...
          </>
        ) : (
          <>
            <Check className="w-4 h-4 mr-2" />
            Confirmer l'association
          </>
        )}
      </Button>
    </div>
  );
};

export default ActionButtons;
